// @ts-ignore
/* eslint-disable */
import request from '@/utils/request';

/** AdminForgotPasswordHandler POST /grnt/admin/forgot-password */
export async function postGrntAdminForgotPassword(
  body: API.AdminForgotPasswordRequest,
  options?: { [key: string]: any }
) {
  return request<any>('/grnt/admin/forgot-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** AdminLoginHandler POST /grnt/admin/login */
export async function postGrntAdminLogin(options?: { [key: string]: any }) {
  return request<any>('/grnt/admin/login', {
    method: 'POST',
    ...(options || {}),
  });
}

/** AdminResetPasswordHandler POST /grnt/admin/reset-password */
export async function postGrntAdminResetPassword(
  body: API.AdminResetPasswordRequest,
  options?: { [key: string]: any }
) {
  return request<any>('/grnt/admin/reset-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** AdminValidateResetTokenHandler POST /grnt/admin/validate-reset-token */
export async function postGrntAdminValidateResetToken(
  body: API.AdminValidateResetTokenRequest,
  options?: { [key: string]: any }
) {
  return request<any>('/grnt/admin/validate-reset-token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** HealthCheckHandler GET /grnt/health */
export async function getGrntHealth(options?: { [key: string]: any }) {
  return request<any>('/grnt/health', {
    method: 'GET',
    ...(options || {}),
  });
}

/** ValidateOrgInviteCodeHandler GET /grnt/invite-code/validate */
export async function getGrntInviteCodeValidate(options?: { [key: string]: any }) {
  return request<any>('/grnt/invite-code/validate', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GitHubOAuthRedirectHandler GET /grnt/oauth/github */
export async function getGrntOauthGithub(options?: { [key: string]: any }) {
  return request<any>('/grnt/oauth/github', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GitHubOAuthCallbackHandler GET /grnt/oauth/github/callback */
export async function getGrntOauthGithubCallback(options?: { [key: string]: any }) {
  return request<any>('/grnt/oauth/github/callback', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GoogleOAuthRedirectHandler GET /grnt/oauth/google */
export async function getGrntOauthGoogle(options?: { [key: string]: any }) {
  return request<any>('/grnt/oauth/google', {
    method: 'GET',
    ...(options || {}),
  });
}

/** GoogleOAuthCallbackHandler GET /grnt/oauth/google/callback */
export async function getGrntOauthGoogleCallback(options?: { [key: string]: any }) {
  return request<any>('/grnt/oauth/google/callback', {
    method: 'GET',
    ...(options || {}),
  });
}

/** OAuthProvidersHandler GET /grnt/oauth/providers */
export async function getGrntOauthProviders(options?: { [key: string]: any }) {
  return request<any>('/grnt/oauth/providers', {
    method: 'GET',
    ...(options || {}),
  });
}

/** RuntimeConfigHandler GET /grnt/runtime-config */
export async function getGrntRuntimeConfig(options?: { [key: string]: any }) {
  return request<any>('/grnt/runtime-config', {
    method: 'GET',
    ...(options || {}),
  });
}

/** UserLoginHandler POST /grnt/user/login */
export async function postGrntUserLogin(options?: { [key: string]: any }) {
  return request<any>('/grnt/user/login', {
    method: 'POST',
    ...(options || {}),
  });
}
